import { render, staticRenderFns } from "./ExpandBlock.vue?vue&type=template&id=58e7f052&scoped=true"
import script from "./ExpandBlock.vue?vue&type=script&lang=js"
export * from "./ExpandBlock.vue?vue&type=script&lang=js"
import style0 from "./ExpandBlock.vue?vue&type=style&index=0&id=58e7f052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e7f052",
  null
  
)

export default component.exports